import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import ErrorMsg from "../../components/form/errorMsg";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { settingsPrivacyPolicyView } from "../../redux/actions/settingAction";
import { useDispatch } from "react-redux";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";
import { useNavigate } from "react-router-dom";

const PrivacyPolicyView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [privacyPolicyData, setPrivacyPolicyData] = useState("");

  useEffect(() => {
    dispatch(settingsPrivacyPolicyView(onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    console.log(data);
    setPrivacyPolicyData(data.data.data);
  };

  const onError = (err) => {
    console.log(err);
  };

  const initialValues = {
    text: privacyPolicyData?.privacy,
  };
  const validationSchema = Yup.object().shape({
    text: Yup.string().required("Required"),
  });

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }],
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ align: "" }],
    ],
  };

  const onSubmit = (values) => {
    console.log(values);
  };

  return (
    <>
      <div></div>
      <div className="p-4">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          {({ setFieldValue, values }) => (
            <Form className="">
              <div className="faq-form-width ms-4 my-4 p-4">
                <div className="mb-3">
                  <span className="fs_20 fw_400">Privay Policy</span>
                </div>
                <div className="faq-text-container w-100">
                  <Field name="text">
                    {({ field }) => (
                      <ReactQuill
                        value={field.value}
                        onChange={field.onChange(field.name)}
                        modules={modules}
                        style={{
                          maxHeight: "400px",
                          height: "60vh",
                          borderRadius: "15px",
                        }}
                        className={"quill"}
                        placeholder={"Enter privacy policy here"}
                      />
                    )}
                  </Field>
                </div>
                <ErrorMsg name={"text"} />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default PrivacyPolicyView;
